module.exports = __webpack_public_path__ + "static/media/app_autoboox.37a48659.jpg";